import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import download from 'downloadjs';
import newunicommerceproduct from '../newunicommerceproduct'
import Loader from './../../shared/loader'
import {
  Validator
} from 'vee-validate'
import Pagination from './../../shared/pagination'

export default {
  name: 'product',
  components: {
    //Paginate,
    Pagination,
    newunicommerceproduct,
    Loader,
    DatePicker
  },
  data: function() {
    return {
      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageLimit: 50,
      Chanelsearch:'',
      listfilterChannelData:[],
      productcategoryname: '',
      subcategoryname: '',
      // totalRows:0,
      userid: '',
      // currentPage: 0,
      addProductFlag: false,
      viewProductFlag: false,
      editProductFlag: false,
      listProductData: [],
      listProductDataCsv: [],
      listProductCategory: [],
      listProductsubCategory: [],
      clientproductid: '',
      productid: '',
      productname: '',
      productcategory: '',
      productsubcategory: '',
      UOMerrors: '',
      brand: '',
      terms: false,
      expERR: '',
      dateErr: false,
      id: '',
      clientaction: '',
      isError: '',
      isUOMError: '',
      isuomtempError: '',
      ismaxtempError: '',
      UOMmaxerrors: '',
      ismintempError: '',
      isLoading: false,
      UOMtemperrors: '',
      UOMminerrors: '',
      ShowList: true,
      disableButton: false,
      editproductmodal: false,
      showProductList:true,
      showpoform: false,
      listMerchantIdData: [],
      listProductcategoryData: [],
      listsubProductcategoryData: [],
      model: {
        productid: '',
        productname: '',
        productdescription: '',
        productcategory: '',
        brand: '',
      },
      // initialize form field
      defaultimage: 'http://tplstage.xbees.in/tplappv1/static/img/noimg.png',
      productDetailModal: false,
      productDetailData: {
        attribute1: "",
        brand: "",
        cgst: "",
        clientid: "",
        clientproductid: "",
        controltype: "",
        createdby: "",
        createddatetime: "",
        expirycontrolled: "",
        expirydate: "",
        hsncode: "",
        hsnrate: "",
        igst: "",
        isflammable: "0",
        isfragile: "0",
        ishazardous: "0",
        isliquid: "0",
        lotcontrol: "0",
        nocontrol: "0",
        isserialcontrol: "0",
        istempsensitive: "0",
        lastmodifiedby: "",
        lastmodifieddate: "",
        maxtemp: "",
        merchantid: "",
        mfgcode: "",
        mintemp: "",
        mrp: "",
        primaryuom: "",
        productcategory: "",
        productdescription: "",
        productid: "",
        productimage: "",
        productname: "",
        productsubcategory: "",
        producttype: "",
        revisionno: "",
        secondaryuom: "",
        sgst: "",
        shelflifeduration: "",
        shelflifeuom: "",
        stickername: "",
        unitbreadth: "",
        unitdimensonuom: "",
        unitheight: "",
        unitlength: "",
        unitweight: "",
        unitweightuom: "",
        uomtemp: ""
      },
      listClientData: [],
      // pageCount: 0,
      // pageNo: 0,
      // pageLimit: 50,
      user_type: '',
      client: '',
      clientid: '',
      warehouseid: '',
      showSelectClient: false,
      ClientErr: '',
      tabIndex: 0,
      addproduct: {
        clientid: '',
        productid: '',
        merchantid: '',
        merchantname: '',
        maxtemp: '',
        isimgselected: 0,
        isimguploaded: 0,
        createdbyEmail: '',
        mintemp: '',
        productname: '',
        productcategory: '',
        productcategoryname: '',
        subcategoryname: '',
        productsubcategory: '',
        productdescription: '',
        categoryname: '',
        producttype: '',
        brand: '',
        clientproductid: '',
        productimage: '',
        hsncode: '',
        hsnrate: '',
        shelflifeduration: '',
        shelflifeuom: '',
        primaryuom: '',
        secondaryuom: '',
        unitweight: '',
        unitweightuom: '',
        fileupload: '',
        unitdimensonuom: '',
        unitlength: '',
        unitbreadth: '',
        unitheight: '',
        uomtemp: '',
        mfgcode: '',
        attribute1: '',
        lotcontrol: 0,
        nocontrol: 0,
        isserialcontrol: 0,
        ishazardous: 0,
        isfragile: 0,
        isflammable: 0,
        isliquid: 0,
        istempsensitive: 0,
        controltype: '',
        filetype: '',
        isactive: '',
        stickername: '',
        createddatetime: '',
        lastmodifieddate: '',
        lastmodifiedby: '',
        revisionno: '',
        inactivedate: '',
        inactiveby: '',
        expirycontrolled: 0,
        eancode: '',
        serializecontrol: 0,
        lotcontrol: '',
        strength: '',
        subbrand: '',
        color: '',
        size: '',
        velocitycode: '',
        mfgcontrolled: 0,
        unitprice: '',
        unitheightuom: '',
        unitlengthuom: '',
        unitbreadthuom: '',
        flipkartProductId: '',
        productTax: 0,
        amazonProductId: ''
      },

    }
  },
  created: function() {},
  // when a page loads,mounted() will be call
  filters: {
    moment: function(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    senddate: function(date) {
      return moment(date).format('YYYY-MM-DD');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.user_type = userdetail.utype;
    this.createdbyEmail = userdetail.email;
    this.userid = userdetail.userid;

    var innerpermissionEncrypt = window.localStorage.getItem('innerpermissiondata')
    var innerbytes = CryptoJS.AES.decrypt(innerpermissionEncrypt.toString(), 'Key');
    var innerplaintext = innerbytes.toString(CryptoJS.enc.Utf8);
    var innerdetail = JSON.parse(innerplaintext);
    this.getComponentPermission(innerdetail);
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client;
    if(this.clientid!=='undefined'){
      this.getChannelList();
    }  
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        // this.getClientList();
        // this.getProductCategory();
        // this.getSubcategoryList();

        break;
      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        this.getProductData();
        // this.getProductCategory();
        //this.getProductcategorylist();
        // this.getSubcategoryList();
        break;
      case 'warehouse_user':
        this.warehouseid = userdetail.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();
        // this.getProductCategory();

      default:
        //this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }
  },
  methods: {
    getProductCategory() {

      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      if (this.user_type = "client_user") {
        this.input = ({
          clientid: this.clientid
        })
      } else {
        this.input = ({
          clientid: this.clientid,
        });
      }

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getProductCategory',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          this.listProductCategory = result.data.data;
        }, error => {
          console.error(error);
        });

    },
    getProductSubCategory() {

      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.listProductsubCategory = [];
      if (this.productcategoryname == "") {
        return false;
      } else {
        this.input = ({
          clientid: this.clientid,
          productcategory: this.productcategoryname
        });
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getProductSubcategory',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr,
            }
          })
          .then(result => {
            this.listProductsubCategory = result.data.data;
          }, error => {
            console.error(error);
          });
      }
    },
    //open new form(popup)
    jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = []) {
      var csvData = '';
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ',';
      }
      csvData = csvData.slice(0, csvData.length - 1);
      csvData += '\r\n';
      //Data
      data.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + ''; // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilter.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
              else
                csvData += escapedCSV + ',';
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1);
        csvData += '\r\n';
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n');
      }
      filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData;
    },
    getChannelList() {
      this.pageNo = this.totalPage = 0;

      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.input = ({

        clientid: this.clientid,


      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getunicomchannelmaster',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          this.listfilterChannelData = result.data.data[0].data;
        }, error => {
          console.error(error);
        });

    },
    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime);
      download(blob, filename, mime);
    },

    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      let bstr = atob(base64);
      let n = bstr.length;
      let u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    // getClientList() {
    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.listClientData = JSON.parse(plaintextclient);
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     this.pageNo = this.pageCount = 0;
    //     this.input = ({
    //       warehouseid: this.warehouseid,
    //     });
    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //         'data': this.input,
    //         headers: {
    //           'Authorization': 'Bearer ' + myStr,
    //         }
    //       })
    //       .then(result => {
    //         this.listClientData = result.data.data;
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },
    getComponentPermission(innerdetail) {
      var component = 'product';
      var innerpermArr = {};
      for (var i = 0; i < innerdetail.length; i++) {
        if (innerdetail[i].controllerurl == component) {
          innerpermArr = innerdetail[i].permission;
          break;
        }
      }
      if (JSON.stringify(innerpermArr) == 'null') {
        //alert("wrong");
      } else {
        for (var i = 0; i < innerpermArr.length; i++) {
          if (innerpermArr[i].id == 'add') {
            this.addProductFlag = true;
          }
          if (innerpermArr[i].id == 'view') {
            this.viewProductFlag = true;
          }
          if (innerpermArr[i].id == 'edit') {
            this.editProductFlag = true;
          }
        }
      }

    },
    // clientSelected() {
    //   this.clientid = this.client;
    //   this.pageNo = this.pageCount = 0;
    //   if (this.clientid) {
    //     this.getChannelList();

    //   }
    // },
    //to get productcategory name list


    getProductRowData(data) {
      this.getProductCategory();
      this.tabIndex = 0;
      this.showpoform = true;
      this.ShowList = false;
      this.addproduct.productid = data.productid;
      this.addproduct.clientproductid = data.clientproductid;
      this.addproduct.merchantname = data.merchantid;
      this.addproduct.flipkartProductId = data.flipkartid;
      this.addproduct.productTax = Number(data.producttax);
      this.addproduct.amazonProductId = data.amazonid;
      this.addproduct.productname = data.productname;
      this.addproduct.mrp = data.mrp;
      this.addproduct.productdescription = data.productdescription;
      // this.getProductcategorylist();
      this.addproduct.productcategoryname = data.productcategory;
      this.getSubcategoryList();
      this.addproduct.productsubcategory = data.productsubcategory;
      this.addproduct.producttype = data.producttype;
      this.addproduct.brand = data.brand;
      this.addproduct.filetype = data.productimage;
      this.addproduct.fileupload = data.productimage;
      this.addproduct.hsncode = data.hsncode;
      this.addproduct.hsnrate = data.hsnrate;
      this.addproduct.shelflifeduration = data.shelflifeduration;
      this.addproduct.primaryuom = data.primaryuom;
      this.addproduct.secondaryuom = data.secondaryuom;
      this.addproduct.unitweight = data.unitweight;
      this.addproduct.unitweightuom = data.unitweightuom;
      this.addproduct.unitdimensonuom = data.unitdimensonuom;
      this.addproduct.unitlength = data.unitlength;
      this.addproduct.unitbreadth = data.unitbreadth;
      this.addproduct.unitheight = data.unitheight;
      this.addproduct.uomtemp = data.uomtemp;
      this.addproduct.mintemp = data.mintemp;
      this.addproduct.maxtemp = data.maxtemp;
      this.addproduct.attribute1 = data.attribute1;
      this.addproduct.lotcontrol = Number(data.lotcontrol);
      this.addproduct.nocontrol = Number(data.nocontrol);
      this.addproduct.isserialcontrol = Number(data.isserialcontrol);
      this.addproduct.ishazardous = Number(data.ishazardous);
      this.addproduct.isfragile = Number(data.isfragile);
      this.addproduct.isflammable = Number(data.isflammable);
      this.addproduct.isliquid = Number(data.isliquid)
      this.addproduct.mfgcode = data.mfgcode;
      this.addproduct.istempsensitive = Number(data.istempsensitive);
      this.addproduct.isactive = data.isactive;
      this.addproduct.stickername = data.stickername;
      this.addproduct.createddatetime = data.createddatetime;
      this.addproduct.lastmodifieddate = data.lastmodifieddate;
      this.addproduct.lastmodifiedby = data.lastmodifiedby;
      this.addproduct.revisionno = data.revisionno;
      this.addproduct.inactivedate = data.inactivedate;
      this.addproduct.inactiveby = data.inactiveby;
      this.addproduct.expirycontrolled = Number(data.expirycontrolled);
      this.addproduct.eancode = data.eancode;
      this.addproduct.serializecontrol = Number(data.serializecontrol);
      this.addproduct.lotcontrol = Number(data.lotcontrol);
      this.addproduct.strength = data.strength;
      this.addproduct.subbrand = data.subbrand;
      this.addproduct.color = data.color;
      this.addproduct.size = data.size;
      this.addproduct.velocitycode = data.velocitycode;
      this.addproduct.mfgcontrolled = Number(data.mfgcontrolled);
      this.addproduct.unitprice = data.unitprice;
      this.addproduct.unitheightuom = data.unitheightuom;
      this.addproduct.unitlengthuom = data.unitlengthuom;
      this.addproduct.unitbreadthuom = data.unitbreadthuom;
      this.ismintempError = '';
      this.ismaxtempError = '';
      this.isuomtempError = '';
      this.addproduct.shelflifeuom = data.shelflifeuom.trim();
      this.$validator.reset();
      this.errors.clear();
    },
    // to get subcategory list
    getSubcategoryList() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.listProductsubCategory = [];
      this.input = ({
        "clientid": this.clientid,
        "productcategory": this.productcategoryname
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getProductSubcategory',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          this.listProductsubCategory = result.data.data;
          this.editproductmodal = true;
        }, error => {
          console.error(error);
        })
    },

    getProductDataOnSearch() {
      this.currentPage = this.totalPage = 1;
      this.getProductData();
    },

    getProductData(csvCheck = 0) {
      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageno = this.pageCount = 0;
        return false;
      }
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.isLoading = true;
      var offset = (this.currentPage - 1) * 5
      var limit = 5
      this.input = ({
        offset: offset.toString(),
        limit: this.pageLimit.toString(),
        clientproductid: this.clientproductid.trim(),
        productid: this.productid.trim(),
        name: this.productname.trim(),
        category: this.productcategoryname.trim(),
        subcategory: this.productsubcategory.trim(),
        clientid: window.localStorage.getItem('selectedClient'),
        csvData: csvCheck,
        channelid:this.Chanelsearch
        // userid: this.userid,
      });

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'uniwareproduct',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (csvCheck == 1) {
            if (result.data.data[0].data.data.length > 0) {
              this.listProductDataCsv = [];
              this.csvFields = {
                'amazonid':  this.$t('unicommerceProduct.amazonId'),
                'brand': this.$t('common.brand'),
                'breadth': this.$t('boxList.breadth'),
                'category': this.$t('editedjson.category'),
                'cgst': this.$t('common.cgst'),
                'clientproductid': this.$t('product.clientProductId'),
                'color': this.$t('common.color'),
                'createddatetime': this.$t('common.createdDateTime'),
                'eancode': this.$t('common.eanCode'),
                'flipkartid': this.$t('unicommerce.productStock.flipkartid'),
                'fsn': this.$t('unicommerce.unicommerceProduct.fsn'),
                'height': this.$t('boxList.height'),
                'hsn': this.$t('unicommerce.unicommerceProduct.hsn'),
                'id': this.$t('common.id'),
                'igst': this.$t('common.igst'),
                'imageurl': this.$t('printProductDetails.imageUrl'),
                'isamazon': this.$t('unicommerce.unicommerceProduct.isamazon'),
                'isflipkart': this.$t('unicommerce.unicommerceProduct.isflipkart'),
                'isflipkartsmart': this.$t('unicommerce.unicommerceProduct.isflipkartsmart'),
                'length': this.$t('boxList.length'),
                'mrp': this.$t('common.mrp'),
                'origincountry': this.$t('unicommerce.unicommerceProduct.originCountry'),
                'productdesc': this.$t('product.productDescription'),
                'productid': this.$t('product.productId'),
                'productname': this.$t('product.productName'),
                'producttaxid': this.$t('common.productTaxId'),
                'seller': this.$t('common.seller'),
                'sgst': this.$t('purchaseOrder.sgst'),
                'size': this.$t('common.size'),
                'status': this.$t('common.status'),
                'stylecode': this.$t('unicommerce.unicommerceProduct.styleCode'),
                'subcategory': this.$t('editedjson.subcategory'),
                'taxcode': this.$t('unicommerce.unicommerceProduct.taxcode'),
                'uom':  this.$t('common.uom'),
              };
              var dateFilter = ['createddatetime', 'pickeddate'];
              var skipFilter = [];
              this.listProductDataCsv = result.data.data[0].data.data;
              this.jsonToCSV('product', this.listProductDataCsv, this.csvFields, dateFilter, skipFilter);
            } else {
              if (result.data.status == true) {
                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
              } else {
                this.$alertify.error(result.data.msg.message);
              }
            }
          } else {
            if (result.data.data[0].ErrorCode == -1) {
              this.listProductData = [];
              this.resultCount = 0;
              this.totalRows = 0;
              this.$alertify.error(result.data.data[0].msg);
            } else {
              this.listProductData = result.data.data[0].data.data;
              if(this.listProductData.length == 0){
                this.$alertify.error(result.data.data[0].msg);

              }else{
                this.$alertify.success(result.data.data[0].msg);

              }

              this.totalRows = result.data.data[0].data.count;
              this.resultCount = result.data.data[0].data.count;
              if (this.totalRows <= this.pageLimit) {
                this.totalPage = 1;
              } else {
                this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
              }
            }
          }
          // this.listProductData = result.data.rows;
          // this.ShowList = true;
          this.isLoading = false;
        }, error => {
          console.error(error);
        })
    },

    printproduct(data) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var productid = data.productid;
      var mrp = data.mrp;
      this.input = ({
        productid: productid,
        mrp: mrp,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'printproduct',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data.errorCode == 0) {
            this.$alertify.success(result.data.msg);
          }
        }, error => {
          console.error(error);
        })
    },

    loadProduct(data) {
      this.productDetailModal = true;
      this.productDetailData = data;
    },

    closeProductModal() {
      this.productDetailModal = false;
    },

    imageLoadError() {
      this.productDetailData.productimage = this.defaultimage;
    },
    //changes for edit product
    setPageCounts(total_rows) {
      if (total_rows > 0) {
        if (total_rows <= this.pageLimit) {
          this.pageCount = 1;
        } else {
          this.pageCount = Math.ceil(total_rows / this.pageLimit);
        }
      } else {
        this.pageCount = 0;
      }
    },

    getMerchantList() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        clientid: this.clientid,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'merchantList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          this.listMerchantIdData = result.data;
        }, error => {
          console.error(error);
        })
    },

    Checkshelfduration() {
      if (this.addproduct.shelflifeduration == null) {
        this.isUOMError = '1';
        this.uomyerrors = this.$t('unicommerce.unicommerceProduct.shelflifeError');
      } else {
        this.isUOMError = '0';
        this.uomyerrors = '';
      }
    },

    lifeuom() {
      if (this.addproduct.shelflifeduration != '') {
        this.isUOMError = '';
        this.uomyerrors = '';
      }
    },

    temsensitiveChange() {
      if (this.addproduct.istempsensitive == 0) {
        this.addproduct.mintemp = '';
        this.addproduct.maxtemp = '';
        this.addproduct.uomtemp = '';
        this.ismintempError = '0';
        this.ismaxtempError = '0';
        this.isuomtempError = '0';
        this.UOMtemperrors = '';
        this.UOMmaxerrors = '';
        this.UOMminerrors = ''
        this.addproduct.istempsensitive = 0
      }
    },

    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    //Call page number from pagination
    // getPaginationData(currentPage) {
    // 	this.pageNo = (currentPage - 1) * this.pageLimit;
    // 	this.getProductData();
    // },
    onPageChange(page) {
      this.currentPage = page;
      this.getProductData()
    },

    addNewProduct(){
      this.showProductList = false;
    },
    async callParent(){
      this.showProductList = true;
    },

    validateTab() {
      this.$validator.validateAll('tab1').then((result) => {
        this.tabIndex = 1;

      }).catch(() => {
        this.tabIndex = 0
        console.log('errors exist', this.errors)
      });
    },

    Checktemp() {
      if (Number(this.addproduct.maxtemp) < Number(this.addproduct.mintemp)) {
        this.isError = '1';
        this.Qtyerrors = this.$t('unicommerce.unicommerceProduct.maxtempError');
        this.ismintempError = '';
        this.ismaxtempError = '';
      } else {
        this.ismintempError = '';
        this.ismaxtempError = '';
        this.isError = '';
        this.Qtyerrors = '';
      }
    },

    editProduct() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.addproduct.producttype = this.addproduct.producttype == null ? "" : this.addproduct.producttype

      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        return false;
      }
      if (this.addproduct.istempsensitive == 1) {
        if (this.addproduct.uomtemp == '' || this.addproduct.uomtemp == null && this.addproduct.maxtemp == '' || this.addproduct.maxtemp == null && this.addproduct.mintemp == '' || this.addproduct.mintemp == null) {
          this.ismintempError = '1';
          this.ismaxtempError = '1';
          this.isuomtempError = '1';
          this.UOMtemperrors = this.$t('unicommerce.unicommerceProduct.uomTempError');
          this.UOMmaxerrors = this.$t('unicommerce.unicommerceProduct.maxtempError1');
          this.UOMminerrors = this.$t('unicommerce.unicommerceProduct.minTempError')
          return false;
        } else {
          this.ismintempError = '';
          this.ismaxtempError = '';
          this.isuomtempError = '';
        }
      }

      if (this.isimgselected == 1 && this.isimguploaded == 0) {
        alert('please wait image is uploading');
      }
      if (this.addproduct.fileupload != null) {
        this.addUrl = this.addproduct.fileupload;
      }
      if (this.imagerelativepath != null) {
        this.addUrl = this.imagerelativepath;

      }
      if (this.addproduct.nocontrol == 0) {
        this.addproduct.lotcontrol = 0
        this.addproduct.expirycontrolled = 0
      }
      if (this.addproduct.nocontrol == 1) {
        if (this.addproduct.lotcontrol == 0 && this.addproduct.expirycontrolled == 0) {
          this.$alertify.error("Please select either lotcontrol or expirycontrolled");
          return false;
        }
      }

      this.isLoading = true;
      this.input = ({
        'productid': this.addproduct.productid,
        'clientid': this.clientid,
        'clientproductid': this.addproduct.clientproductid,
        'merchantid': this.addproduct.merchantname ? this.addproduct.merchantname : '',
        'productname': this.addproduct.productname,
        'mrp': Number(this.addproduct.mrp),
        'productdescription': this.addproduct.productdescription,
        'productcategory': this.addproduct.productcategoryname,
        'productsubcategory': this.addproduct.productsubcategory,
        'producttype': this.addproduct.producttype,
        'brand': this.addproduct.brand,
        'productimage': this.addUrl,
        'hsncode': this.addproduct.hsncode,
        'hsnrate': Number(this.addproduct.hsnrate),
        'shelflifeduration': Number(this.addproduct.shelflifeduration),
        'shelflifeuom': this.addproduct.shelflifeuom != null ? this.addproduct.shelflifeuom : '',
        'primaryuom': this.addproduct.primaryuom != null ? this.addproduct.primaryuom : '',
        'secondaryuom': this.addproduct.secondaryuom != null ? this.addproduct.secondaryuom : '',
        'unitweight': Number(this.addproduct.unitweight),
        'unitweightuom': this.addproduct.unitweightuom != null ? this.addproduct.unitweightuom : '',
        'unitdimensonuom': this.addproduct.unitdimensonuom != null ? this.addproduct.unitdimensonuom : '',
        'unitlength': Number(this.addproduct.unitlength),
        'unitbreadth': Number(this.addproduct.unitbreadth),
        'unitheight': Number(this.addproduct.unitheight),
        'uomtemp': this.addproduct.uomtemp != null ? this.addproduct.uomtemp : '',
        'mintemp': Number(this.addproduct.mintemp),
        'maxtemp': Number(this.addproduct.maxtemp),
        'attribute1': this.addproduct.attribute1 != null ? this.addproduct.attribute1 : '',
        'lotcontrol': Number(this.addproduct.lotcontrol),
        'nocontrol': Number(this.addproduct.nocontrol),
        'isserialcontrol': Number(this.addproduct.isserialcontrol),
        'ishazardous': Number(this.addproduct.ishazardous),
        'isfragile': Number(this.addproduct.isfragile),
        'isflammable': Number(this.addproduct.isflammable),
        'isliquid': Number(this.addproduct.isliquid),
        'mfgcode': this.addproduct.mfgcode,
        'istempsensitive': this.addproduct.istempsensitive,
        'stickername': this.addproduct.stickername != null ? this.addproduct.stickername : '',
        'expirycontrolled': Number(this.addproduct.expirycontrolled),
        'eancode': this.addproduct.eancode,
        'serializecontrol': Number(this.addproduct.serializecontrol),
        'subbrand': this.addproduct.subbrand,
        'color': this.addproduct.color,
        'size': this.addproduct.size,
        'velocitycode': this.addproduct.velocitycode != null ? this.addproduct.velocitycode : '',
        'mfgcontrolled': Number(this.addproduct.mfgcontrolled),
        'unitprice': Number(this.addproduct.unitprice),
        'unitheightuom': this.addproduct.unitheightuom != null ? this.addproduct.unitheightuom : '',
        'unitlengthuom': this.addproduct.unitlengthuom != null ? this.addproduct.unitlengthuom : '',
        'unitbreadthuom': this.addproduct.unitbreadthuom != null ? this.addproduct.unitbreadthuom : '',
        'lastmodifieddate': new Date(),
        'lastmodifiedby': this.createdbyEmail,
        'flipkartid': this.addproduct.flipkartProductId,
        'producttax': Number(this.addproduct.productTax),
        'amazonid': this.addproduct.amazonProductId,
      })

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'UpdateProduct',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status == true) {
            this.$alertify.success(response.data.msg );
          } else {
            this.$alertify.error(response.data.msg );
          }
          this.iserror = false;
          this.getProductData();
          this.resetform();
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    resetform() {
      this.ShowList = true;
      this.showpoform = false;
    },

    //end changes for edit product
    createGoogleLink(imageLink, id) {
      var preURL = 'https://drive.google.com/uc?export=view&id=';
      var validUrl = '';
      var tempUrl = imageLink.split('?id=');
      if (tempUrl.length == 1) {
        var tempURL = imageLink.split('https://drive.google.com/file/d/');
        var tempURL1 = tempURL[1].split('/view');
        var validUrl = preURL + tempURL1[0];
        //this.productimage = validUrl;
        $("#" + id).attr("src", validUrl);
      } else {
        validUrl = preURL + tempUrl[1];
        $("#" + id).attr("src", validUrl);
      }
    },

    resetFlt() {
      this.Chanelsearch='';
      this.totalRows = 0;
      this.productid = '';
      this.clientproductid = '';
      this.productname = '';
      this.client = '';
      this.listProductData = [];
      this.listProductDataCsv = [];
      this.productcategoryname='';
      this.productsubcategory='';
      this.totalPage = 0;
      //this.currentPage = 1,
      this.listProductCategory = [];
      this.listProductsubCategory = [];
      this.productsubcategory = '';
      this.productcategory = '';
      this.Chanelsearch ='';

      if (this.user_type == 'warehouse_user')
        this.client = '';
      else if (this.user_type == 'client_user')
        this.warehouse = '';
      else {
        this.client = '';
        this.warehouse = '';
      }
      // if (this.clientid && this.user_type == 'client_user') {
      // 	this.getProductData();
      // } else {
      // 	this.clientid = '';
      // }
    },

    //validate all form fields on onsubmit()
    onSubmit: function() {
      this.$validator.validateAll().then(() => {
        console.log('form is valid', this.model);
      }).catch(() => {
        console.log('errors exist', this.errors);
      });
    },


    // function using for file uploading
    handleFileUpload() {
      if (this.clientid == '') {
        this.ClientErr = this.$t('common.clientError');
        return false;
      }
      this.isimgselected = 1;
      this.isimguploaded = 0;
      this.file = this.$refs.file.files[0];
      this.submitFile();
    },
    submitFile() {
      if (this.clientid == '') {
        this.ClientErr = this.$t('common.clientError');
        return false;
      }
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      var formData = new FormData();
      formData.append('file', this.file);
      formData.append('clientid', this.clientid);
      axios.post(apiUrl.api_url + 'upload_file2',
          formData, {
            headers: {
              'Authorization': 'Bearer ' + myStr,
              'Content-Type': 'multipart/form-data'
            },
          })
        .then((response) => {
          this.imagerelativepath = response.data.path;
          this.filename = response.data.filename
          this.isimguploaded = 1;
          if (response.status == true) {
            this.error_seen = false;
            this.success_seen = true;
            this.error_message = '';
            this.success_message = response.data.numrows + " items added successfully";
          } else {
            this.error_seen = true;
            this.success_seen = false;
            this.error_message = response.message;
            this.success_message = '';
          }
        })
        .catch(function() {
          ;
          console.log('FAILURE!!');
        });
    },
    //end of function for file uploading
  }
}



// WEBPACK FOOTER //
// ./src/views/components/uniware/unicommerceproduct/unicommerceproduct.component.js